<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">週別部門別供給高GP予算進捗</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title" forcedEnabledMode="true" style="white-space:nowrap;">対象受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_lOrderCode" #txti_lOrderCode
              [subid]="'txti_lOrderCode'" [autofocus]="true" [required]="true" [tabindex]="0"
              [forcedEnabledMode]="'true'" [(ngModel)]="kymw2800Model.orderCodeFrom">
            </app-order-code-text-input>
            <label forcedEnabledMode="true">～</label>
            <app-order-code-text-input id="txti_rOrderCode" #txti_rOrderCode
              [subid]="'txti_rOrderCode'" [required]="true" [tabindex]="0" [forcedEnabledMode]="'true'"
              [(ngModel)]="kymw2800Model.orderCodeTo">
            </app-order-code-text-input>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_printOut" class="btn-primary" [tabindex]="0" (click)="printOutBtnClicked()"
            forcedEnabledMode="true">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>